import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "react-tooltip";
import Link from "next/link";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { ApiDropRater } from "@/generated/models/ApiDropRater";
import DropVoteProgressing from "@/components/drops/view/utils/DropVoteProgressing";
import { ApiDropContextProfileContext } from "@/generated/models/ApiDropContextProfileContext";
interface MemeDropVoteStatsProps {
  readonly current: number | null | undefined;
  readonly projected: number | null | undefined;
  readonly votingCreditType: string;
  readonly ratersCount: number | null | undefined;
  readonly topVoters: ApiDropRater[];
  readonly userContext?: ApiDropContextProfileContext | null | undefined;
}
export default function MemeDropVoteStats(t0) {
  const $ = _c(54);
  const {
    current,
    projected,
    votingCreditType,
    ratersCount,
    topVoters,
    userContext
  } = t0;
  const isPositive = (current ?? 0) >= 0;
  let hasUserVoted;
  let isUserVoteNegative;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let userVote;
  if ($[0] !== current || $[1] !== isPositive || $[2] !== projected || $[3] !== topVoters || $[4] !== userContext?.rating || $[5] !== votingCreditType) {
    const firstThreeVoters = topVoters?.slice(0, 3) ?? [];
    hasUserVoted = userContext?.rating !== undefined && userContext?.rating !== 0;
    userVote = userContext?.rating ?? 0;
    isUserVoteNegative = userVote < 0;
    t4 = "tw-flex tw-items-center tw-flex-wrap tw-gap-x-6 tw-gap-y-2";
    const t6 = `tw-text-sm tw-font-semibold ${isPositive ? "tw-text-emerald-500" : "tw-text-rose-500"} `;
    const t7 = current ?? 0;
    let t8;
    if ($[14] !== t7) {
      t8 = formatNumberWithCommas(t7);
      $[14] = t7;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    let t9;
    if ($[16] !== t6 || $[17] !== t8) {
      t9 = <span className={t6}>{t8}</span>;
      $[16] = t6;
      $[17] = t8;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] !== votingCreditType) {
      t10 = <span className="tw-text-sm tw-text-iron-500 tw-whitespace-nowrap"><span className="tw-font-medium">{votingCreditType} total</span></span>;
      $[19] = votingCreditType;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    let t11;
    if ($[21] !== current || $[22] !== projected) {
      t11 = <DropVoteProgressing current={current} projected={projected} />;
      $[21] = current;
      $[22] = projected;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    let t12;
    if ($[24] !== t10 || $[25] !== t11) {
      t12 = <div className="tw-flex tw-items-baseline tw-gap-x-1.5">{t10}{t11}</div>;
      $[24] = t10;
      $[25] = t11;
      $[26] = t12;
    } else {
      t12 = $[26];
    }
    if ($[27] !== t12 || $[28] !== t9) {
      t5 = <div className="tw-flex tw-items-baseline tw-gap-x-1">{t9}{t12}</div>;
      $[27] = t12;
      $[28] = t9;
      $[29] = t5;
    } else {
      t5 = $[29];
    }
    t3 = "tw-flex tw-items-center tw-gap-2";
    t1 = "tw-flex tw-items-center -tw-space-x-2";
    t2 = firstThreeVoters.map(_temp2);
    $[0] = current;
    $[1] = isPositive;
    $[2] = projected;
    $[3] = topVoters;
    $[4] = userContext?.rating;
    $[5] = votingCreditType;
    $[6] = hasUserVoted;
    $[7] = isUserVoteNegative;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = userVote;
  } else {
    hasUserVoted = $[6];
    isUserVoteNegative = $[7];
    t1 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    userVote = $[13];
  }
  let t6;
  if ($[30] !== t1 || $[31] !== t2) {
    t6 = <div className={t1}>{t2}</div>;
    $[30] = t1;
    $[31] = t2;
    $[32] = t6;
  } else {
    t6 = $[32];
  }
  const t7 = ratersCount ?? 0;
  let t8;
  if ($[33] !== t7) {
    t8 = formatNumberWithCommas(t7);
    $[33] = t7;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  const t9 = ratersCount === 1 ? "voter" : "voters";
  let t10;
  if ($[35] !== t9) {
    t10 = <span className="tw-text-iron-500 tw-font-normal">{t9}</span>;
    $[35] = t9;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  let t11;
  if ($[37] !== t10 || $[38] !== t8) {
    t11 = <span className="tw-text-white tw-font-semibold tw-text-sm">{t8}{" "}{t10}</span>;
    $[37] = t10;
    $[38] = t8;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  let t12;
  if ($[40] !== t11 || $[41] !== t3 || $[42] !== t6) {
    t12 = <div className={t3}>{t6}{t11}</div>;
    $[40] = t11;
    $[41] = t3;
    $[42] = t6;
    $[43] = t12;
  } else {
    t12 = $[43];
  }
  let t13;
  if ($[44] !== hasUserVoted || $[45] !== isUserVoteNegative || $[46] !== userVote || $[47] !== votingCreditType) {
    t13 = hasUserVoted && <div className="tw-flex tw-items-center tw-gap-x-1.5"><div className="tw-flex tw-items-baseline tw-gap-x-1"><span className="tw-text-sm tw-font-normal tw-text-iron-400">Your vote:</span><span className={`tw-text-sm tw-font-semibold ${isUserVoteNegative ? "tw-text-rose-500" : "tw-text-emerald-500"}`}>{isUserVoteNegative && "-"}{formatNumberWithCommas(Math.abs(userVote))}{" "}<span className="tw-text-iron-400 tw-font-normal">{votingCreditType}</span></span></div></div>;
    $[44] = hasUserVoted;
    $[45] = isUserVoteNegative;
    $[46] = userVote;
    $[47] = votingCreditType;
    $[48] = t13;
  } else {
    t13 = $[48];
  }
  let t14;
  if ($[49] !== t12 || $[50] !== t13 || $[51] !== t4 || $[52] !== t5) {
    t14 = <div className={t4}>{t5}{t12}{t13}</div>;
    $[49] = t12;
    $[50] = t13;
    $[51] = t4;
    $[52] = t5;
    $[53] = t14;
  } else {
    t14 = $[53];
  }
  return t14;
}
function _temp2(voter) {
  return <div key={voter.profile.handle}><Link href={`/${voter.profile.handle}`} onClick={_temp} data-tooltip-id={`vote-stats-${voter.profile.handle}`}>{voter.profile.pfp ? <img className="tw-w-6 tw-h-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800 tw-object-contain" src={voter.profile.pfp} alt="Recent voter" /> : <div className="tw-w-6 tw-h-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800" />}</Link><Tooltip id={`vote-stats-${voter.profile.handle}`} place="top" style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }}><span className="tw-text-xs">{`${voter.profile.handle} - ${formatNumberWithCommas(voter.rating)}`}</span></Tooltip></div>;
}
function _temp(e) {
  return e.stopPropagation();
}